'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isCurrencySymbolOnLeft = exports.getISOCodeForCurrencySymbol = exports.getCurrencySymbolForISOCode = undefined;

var _currencies = require('./currencies.json');

var _currencies2 = _interopRequireDefault(_currencies);

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCurrencySymbolForISOCode = exports.getCurrencySymbolForISOCode = function getCurrencySymbolForISOCode() {
  var currencyISOCode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants.DEFAULT_CURRENCY;

  var currency = _currencies2.default[currencyISOCode] || _currencies2.default[_constants.DEFAULT_CURRENCY];

  return currency.symbol;
};

var getISOCodeForCurrencySymbol = exports.getISOCodeForCurrencySymbol = function getISOCodeForCurrencySymbol() {
  var currencySymbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants.DEFAULT_CURRENCY_SYMBOL;

  var ISOCode = Object.keys(_currencies2.default).find(function (key) {
    return _currencies2.default[key].symbol === currencySymbol;
  });

  return ISOCode || _constants.DEFAULT_CURRENCY;
};

var isCurrencySymbolOnLeft = exports.isCurrencySymbolOnLeft = function isCurrencySymbolOnLeft(currencyISOCode) {
  var currency = _currencies2.default[currencyISOCode] || _currencies2.default[_constants.DEFAULT_CURRENCY];

  return currency.symbolOnLeft;
};

exports.default = {
  getCurrencySymbolForISOCode: getCurrencySymbolForISOCode,
  getISOCodeForCurrencySymbol: getISOCodeForCurrencySymbol,
  isCurrencySymbolOnLeft: isCurrencySymbolOnLeft
};
//# sourceMappingURL=currency.js.map